var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSmilingStar = function SvgSmilingStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8 .333 2.817 4.122 4.791 1.406-3.05 3.954.143 4.99L8 13.127l-4.702 1.678.144-4.99L.39 5.86l4.791-1.406L7.999.333ZM6.665 8H5.333a2.667 2.667 0 0 0 5.33.133L10.666 8H9.333a1.333 1.333 0 0 1-2.664.1L6.666 8Z",
    fill: "#fff"
  })));
};
export default SvgSmilingStar;